import { TextareaHTMLAttributes } from 'react';

interface TextAreaFieldProps
	extends TextareaHTMLAttributes<HTMLTextAreaElement> {
	label?: string;
	name: string;
	rows?: number;
}

const TextAreaField: React.FC<TextAreaFieldProps> = ({
	label,
	name,
	rows = 4,
    className,
	...props
}) => {
	return (
		<div className="space-y-1">
			{label && (
				<label
					htmlFor={name}
					className="block text-sm text-gray-700 dark:text-gray-300 font-medium"
				>
					{label}
				</label>
			)}
			<textarea
				id={name}
				name={name}
				rows={rows}
				className={`w-full px-4 py-3 border rounded-lg text-sm outline-none border-gray-400 focus:ring-1 focus:ring-gray-500 resize-none ${className || ''}`}
				style={{ fontSize: 16, ...(props.style || {}) }}
				{...props}
			/>
		</div>
	);
};

export default TextAreaField;
